var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "./LinkImageList.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("./LinkImageList.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.LinkImageList);
    global.LinkImageList = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _LinkImageList) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);

  var LinkImageList = function LinkImageList(_ref) {
    var className = _ref.className,
        links = _ref.links,
        tracking = _ref.tracking,
        trackingEnabled = _ref.trackingEnabled;
    return links.length === 0 ? null : /*#__PURE__*/_react.default.createElement(_LinkImageList.StyledList, {
      className: className
    }, links.map(function (_ref2) {
      var href = _ref2.href,
          label = _ref2.label,
          src = _ref2.src;
      return /*#__PURE__*/_react.default.createElement(_LinkImageList.StyledItem, {
        key: "href-".concat(href, "-label-").concat(label)
      }, /*#__PURE__*/_react.default.createElement(_LinkImageList.StyledLink, {
        href: href,
        onClick: function onClick(event) {
          if (trackingEnabled) {
            tracking({
              event: event,
              href: href,
              label: label,
              src: src
            });
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_LinkImageList.StyledImage, {
        src: src,
        alt: label
      })));
    }));
  };

  LinkImageList.propTypes = {
    className: _propTypes.default.string,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      href: _propTypes.default.string.isRequired,
      label: _propTypes.default.string.isRequired,
      src: _propTypes.default.string.isRequired
    })).isRequired,
    tracking: _propTypes.default.func,
    trackingEnabled: _propTypes.default.bool
  };
  LinkImageList.defaultsProps = {
    className: '',
    links: [],
    tracking: function tracking() {},
    trackingEnabled: false
  };
  var _default = LinkImageList;
  _exports.default = _default;
});